export function parseCountry(enLocale) {
  let countrySAR = ['HK', 'MO'];
  let enLocaleCountries = enLocale;
  countrySAR.forEach((code) => {
    enLocaleCountries.countries[code] = `${enLocale.countries[code]} SAR`;
  });
  return enLocaleCountries;
}
